// extracted by mini-css-extract-plugin
export default {"root":"R629TZXVYfY43tden713","wrap":"BSNqn8eMW5EJe8AcmXj0","icon":"ifuDYTxDCnjfOwldQQu0","copy":"DFOLKTe2WhZAxpDdghEZ","back":"A0tHMVMxD2AouFvOULFH"};